'use client';
import { DotsVertical, FileSearch02, LogOut02 } from '@ethsign/icons';
import { Dropdown } from '@ethsign/ui';
import { IDropdownItem } from '@ethsign/ui/dist/Menu';
import { shortenWalletAddress } from '@ethsign/utils-web';
import { BookTemplate } from 'lucide-react';

import { WalletIconByType } from '@/constants/network';
import { usePermission, useRouter } from '@/hooks';
import { logout } from '@/services';
import { ICurrentUser, USER_ROLE_ENUM } from '@/types';
import { getUserWalletType, WalletType } from '@/utils';
import { WalletFactory } from '@/utils/wallet/WalletFactory';

export const UserInfo = ({ user }: { user: ICurrentUser }) => {
  const router = useRouter();

  const walletType = getUserWalletType(user!.chainType as WalletType, user!.authType);
  const WalletIcon = WalletIconByType[walletType];
  const hasTemplateAdmin = usePermission(USER_ROLE_ENUM.TEMPLATEADMIN);

  const handleLogOut = async () => {
    const walletType = getUserWalletType(user!.chainType as WalletType, user!.authType);
    const wallet = await WalletFactory.getWallet(walletType, user.displayAddress);
    if (wallet?.disconnect) {
      wallet.disconnect();
    }
    await logout();
    router.replace(`/signin`);
  };

  return (
    <>
      <div className="flex gap-[12px] items-center">
        <div className="px-[14px] h-[42px] border border-gray-100 shadow-xs rounded-md flex gap-[8px] items-center">
          {WalletIcon && <WalletIcon />}
          <span className="text-sm font-medium">{shortenWalletAddress(user?.displayAddress || '', 'shorter')}</span>
        </div>
        <Dropdown
          items={
            [
              {
                label: 'Verify Signature',
                icon: <FileSearch02 size={20} color="#101828" />,
                onClick: async () => {
                  window.open('/verify');
                }
              },
              hasTemplateAdmin
                ? {
                    label: 'Manage Templates',
                    icon: <BookTemplate size={20} color="#101828" />,
                    onClick: async () => {
                      router.replace(`/console/template/list`);
                    }
                  }
                : undefined,
              {
                label: 'Sign out',
                icon: <LogOut02 size={20} color="#101828" />,
                onClick: handleLogOut
              }
            ].filter(Boolean) as IDropdownItem[]
          }
        >
          <div className="rounded-md border p-[8px] border-gray-100 shadow-xs">
            <DotsVertical
              color="#344054"
              size={24}
              onClick={(e: any) => {
                e.stopPropagation();
              }}
            />
          </div>
        </Dropdown>
      </div>
    </>
  );
};
